import { sample } from 'effector';
import {
  changeActiveProjectsEv,
  changeActiveRegionsEv,
  clearActiveProjectsEv,
  clearActiveRegionsEv,
  selectAllEv,
  setDefaultActiveProjectsEv,
  setDefaultRegionsValueEv,
} from './events.js';
import { $activeProjects, $activeRegions } from './stores.js';
import {
  $altaRailwayStartDots,
  $ferryTerminalsStartDots,
  $investProStartDots,
  $kzAirportsStartDots,
  $minresStartPolygons,
} from '../investProModel/index.js';

$activeRegions.reset(clearActiveRegionsEv);
$activeProjects.reset(clearActiveProjectsEv);

sample({
  clock: changeActiveProjectsEv,
  target: $activeProjects,
});

sample({
  clock: changeActiveRegionsEv,
  target: $activeRegions,
});

sample({
  source: $investProStartDots,
  clock: selectAllEv,
  fn: (investProStartDots) => {
    return [
      ...investProStartDots.map((item) => item.properties.id),
      'special_zones',
      'altaRailway',
      'kzAirports',
      'kzHelicopter',
      'ferryTerminals',
      'minres',
      'azs',
      'warehouse',
      'sto',
    ];
  },
  target: $activeProjects,
});

sample({
  clock: setDefaultActiveProjectsEv,
  fn: (clock) => {
    const result = [];
    clock.forEach((item) => {
      if (!result.includes(item.properties.gen_name))
        result.push(item.properties.gen_name);
      result.push(item.properties.id);
    });
    return result;
  },
  target: $activeProjects,
});

sample({
  clock: setDefaultRegionsValueEv,
  fn: (clock) => {
    const result = [];
    clock.forEach((item) => {
      if (!result.includes(item.properties.lvl_1_code))
        result.push(item.properties.lvl_1_code);
      if (!result.includes(item.properties.lvl_2_code))
        result.push(item.properties.lvl_2_code);
    });
    return result;
  },
  target: $activeRegions,
});
